import BaseApi from 'apis/base';
import { getConfig } from 'utils/config';

export default {
  fetchCombinedModuleSummaries: async (locale: string) => {
    // Not sure if this can be called before any of our components mount.
    // waiting for the config promise will ensure that everything happens in order properly,
    // and it will not fetch the config more than once regardless.
    const { HYLIA_ASSETS_URL } = await getConfig();
    return BaseApi.request(
      `${HYLIA_ASSETS_URL}/clinical-content/${locale}/combined-module-summaries.md`,
      {
        method: 'GET',
      },
      undefined,
      true,
    );
  },

  fetchFullModuleContent: async (locale: string) => {
    const { HYLIA_ASSETS_URL } = await getConfig();
    return BaseApi.request(
      `${HYLIA_ASSETS_URL}/clinical-content/${locale}/full-module-content.md`,
      {
        method: 'GET',
      },
      undefined,
      true,
    );
  },
};
